/**
 * Feature flags and tenant/domain-based feature visibility.
 * Use for configurable UI (e.g. Verification button) per subdomain.
 */
import { getSubdomain } from './tenantUtils';
import { getIndigentTenantRules } from '@/modules/Indigent/tenant/indigentTenantRules';

/**
 * Subdomains (tenants) where the Indigent Verification button is visible.
 * Add or remove subdomain strings to control visibility per tenant.
 */
const INDIGENT_VERIFICATION_SUBDOMAINS = new Set<string>([
  // 'langeberg',
  'victorkhanye',
  'demo',
  'ephraim'
]);

const VERIFICATION_SYSTEM_SUBDOMAINS = new Set<string>([
  'demo',
  'langeberg',
  'victorkhanye'
]);

/**
 * Whether the current tenant/subdomain has the Indigent Verification feature enabled.
 * @returns true if Verification button should be shown for indigent records
 */
export const isIndigentVerificationEnabled = (): boolean => {
  const subdomain = getSubdomain();
  if (!subdomain) return false;
  return INDIGENT_VERIFICATION_SUBDOMAINS.has(subdomain.toLowerCase());
};

export const isVerificationSystemEnabled = (): boolean => {
  const subdomain = getSubdomain();
  if (!subdomain) return false;
  return VERIFICATION_SYSTEM_SUBDOMAINS.has(subdomain.toLowerCase());
};

/**
 * Whether Certified ID must be present for indigent supporting documents (create / edit validation).
 * Delegates to indigent tenant rules — see `src/modules/Indigent/tenant/indigentTenantRules.ts`.
 */
export const isIndigentCertifiedIdRequired = (): boolean =>
  getIndigentTenantRules().certifiedIdRequired;
